/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 9th 2024, 6:31:08 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder } from "lib/validation";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
  TaskTemplate,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";

export type TDigitalSigningSettings = {
  set_signers_automatically: boolean;
  minimum_records_before_signing?: number;
  maximum_time_before_signing?: number;
};

export interface DigitalSigningSettings extends ProcessTemplateArtifact, WritableModel<true> {
  settings: TDigitalSigningSettings;
  signing_task_template: TaskTemplate["id"];
}

const SigningSettingsValidationSchema: schemaBuilder.SchemaOf<TDigitalSigningSettings> = schemaBuilder.object().shape({
  set_signers_automatically: schemaBuilder
    .boolean()
    .required("You must specify if signers should be set automatically"),
  minimum_records_before_signing: schemaBuilder.number().optional().nullable(),
  maximum_time_before_signing: schemaBuilder.number().optional().nullable(),
});

export const DigitalSigningSettingsValidationSchema: ProcessTemplateArtifactSchemaType<DigitalSigningSettings> =
  ProcessTemplateArtifactValidationSchema.shape({
    id: schemaBuilder.string().uuid().nullable(),
    settings: SigningSettingsValidationSchema.required(
      "You must provide the settings for the digital signing settings."
    ),
    signing_task_template: schemaBuilder.number().required("You must provide the signing task template."),
  });
